import { useSelector } from "react-redux"
import { RootState } from "store"

export const useGetCampaignDataById = (campaignId: string) => {
    return useSelector((state: RootState) => state.campaigns.items[campaignId]?.data?.campaign)
}

export const useGetCampaignCurrency = (campaignId: string) => {
    return useSelector((state: RootState) => state.campaigns.items[campaignId]?.data?.campaign?.currency)
}